import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { AddressType, CountryAlpha2Code, IdentityDocumentType, LegalType, PersonSex, PhoneType } from '@isyc-react/types';
import { getDossierReadQueryGraphql } from "../../queries";
export const personExample = {
  id: 43121,
  name: 'Diego',
  surname: 'Sánchez',
  surname2: 'Pizjuán',
  email: 'dsanchez@isyc.com',
  code: 'test',
  nativeCity: '',
  phone: {
    type: PhoneType.mobile,
    number: '679133656',
    prefix: '+34',
    principal: true
  },
  sex: PersonSex.MALE,
  birthDate: '1990-05-25T00:00:00Z',
  businessUnitId: 5100,
  businessUnitName: 'General',
  creationTimestamp: '2021-08-13T00:00:00Z',
  modifiedBy: 'system',
  timestamp: '2021-08-13T00:00:00Z',
  createdBy: 'system',
  legal: LegalType.PHYSICAL,
  identityDocument: {
    document: '',
    type: IdentityDocumentType.OTHERS
  },
  maidenName: '',
  matrimonialRegime: 1,
  emailAddresses: [],
  phones: [],
  streetAddress: {
    door: '',
    number: '',
    countryCode: CountryAlpha2Code.ES,
    type: AddressType.POSTAL,
    postalCode: '40000',
    stairs: '',
    locality: '',
    name: 'Calle falsa 123',
    floor: '',
    additionalNameInformation1: '',
    additionalNameInformation2: '',
    district: 'Calle falsa 123',
    streetType: ''
  },
  streetAddresses: [],
  profession: '',
  cno: 1,
  laborRelationship: 1,
  nativeCountry: CountryAlpha2Code.ES,
  nativeProvince: '',
  activitySector: '',
  nationalities: [],
  settingUpDate: '',
  companyType: 0,
  externalReference: '',
  socialSecurityNumber: '',
  resident: false,
  archives: [],
  roleRelatedPerson: 0,
  historicalChanges: [],
  language: 'ES',
  workCompanyName: ''
};
export const dossierExample = {
  __typename: 'DossierDto',
  id: 43124,
  name: 'Dossier 43124',
  businessUnitId: '5100',
  remarks: '',
  hospitalization: {
    admissionDate: '2021-03-17T23:00:00Z'
  },
  statusTreeLevel1: '1',
  participants: [{
    __typename: 'ParticipantDto',
    templateCode: 'PATIENT',
    person: _objectSpread({
      __typename: 'PersonDto'
    }, personExample)
  }],
  archives: [{
    __typename: 'ArchiveDto',
    id: 1001,
    name: 'Consignes - ambulatoire.pdf',
    status: 0,
    businessUnitId: 5100,
    businessUnitName: 'General',
    creationTimestamp: '20210813',
    modifiedBy: 'system',
    timestamp: '20210813',
    createdBy: 'system',
    documents: []
  }, {
    __typename: 'ArchiveDto',
    id: 1002,
    name: 'Consignes - sorties.pdf',
    status: 0,
    businessUnitId: 5100,
    businessUnitName: 'General',
    creationTimestamp: '20210813',
    modifiedBy: 'system',
    timestamp: '20210813',
    createdBy: 'system',
    documents: []
  }, {
    __typename: 'ArchiveDto',
    id: 1003,
    name: 'Consignes - etablissement.pdf',
    status: 0,
    businessUnitId: 5100,
    businessUnitName: 'General',
    creationTimestamp: '20210813',
    modifiedBy: 'system',
    timestamp: '20210813',
    createdBy: 'system',
    documents: []
  }],
  links: [{
    title: 'Example link',
    url: 'http://www.example.fr'
  }]
};
export default [{
  request: {
    query: getDossierReadQueryGraphql(),
    variables: {
      id: 43124
    }
  },
  result: {
    data: {
      dossier_read: dossierExample
    }
  }
}];